module.exports = __webpack_public_path__ + "i18n/nl.22a0a92eedd4f4355fada5a44dce1262.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/nl.json
// module id = 1311
// module chunks = 59